module.exports = __webpack_public_path__ + "static/media/device1.c2ddb8cd.svg";


//////////////////
// WEBPACK FOOTER
// ./public/image/device1.svg
// module id = 21
// module chunks = 0